import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const locationEmployeeCountWidget: DashboardWidgetConfiguration = {
  widgetId: "location.employee-count",
  name: "Employees",
  description: "Employees for the selected dashboard period.",
  apps: [
    "configuration",
  ],
  template: "number",
  query: {
    kind: "single",
    query: {
      version: 1,
      source: "hr.current-employments",
      ...period(1),
      select: [
        {
          type: "aggregate",
          function: "count_distinct",
          field: "employment_id",
          as: "value",
        },
      ],
    },
  },
  inputs: {
    label: "Employees",
    subtext: "",
    icon: "users",
    color: "purple",
    valueFormat: "number",
    valueMultiplier: 1,
  },
  dummyData: {
    value: 0,
    subtext: "Last 30 days",
  },
  limits: {
    minWidth: 2,
    maxWidth: 6,
    minHeight: 1,
    maxHeight: 1,
    defaultWidth: 3,
    defaultHeight: 1,
  },
};
